import React, { Component } from 'react';
import { CardButton } from './CardButton';
import { CardButtonDescription } from './CardButtonDescription';

export class OffenseBox extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CardBoxTitleOuter">
          <p className="CardBoxTitle">
            Offensive Strategy
          </p>
					<p className="CardBoxTitle CardBoxSubtitle">
            Tactical BM is not a good strategy.
          </p>
        </div>
        <div className="CardBoxContainer DoubleCardBox">

					<div className="CardBoxBackground OffensiveBoxBackground" />
					<div className="CardBoxTint" />


          {/*<div className="CardButtonPusher" />*/}
          <CardButton rarity="rare"
											titleBackground="rareTitle"
											cardTitle={ "cycle" }
											className="cycle"
											cardBackground="hog-rider"
											archetypeName="cycle"/>
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building"
											text="Gotta go fast! Play cheap cards to cycle back to your win condition faster than your opponent can cycle to their counter."
											color="redDescription"/>

					<CardButtonDescription rarity="archetypeDescription"
										titleBackground="commonTitle"
										cardTitle={ "building" }
										className="building"
										cardBackground="inferno-tower"
										archetypeName="building"
										text="If you&#8217;re having log problems, I feel bad for ya, son. I’ve got 99 Goblins and your zap hit one. Spam your opponent with small stuff, kind of like that one person you game with who keeps using the same move over and over and over and over."
										color="purpleDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="epic"
											titleBackground="epicTitle"
											cardTitle={ "zap bait" }
											className="zapBait"
											cardBackground="goblin-barrel"
											archetypeName="zapBait"/>

					<CardButtonDescription rarity="archetypeDescription"
										titleBackground="commonTitle"
										cardTitle={ "building" }
										className="building"
										cardBackground="inferno-tower"
										archetypeName="building"
										text="Drop something that your opponent will want to fireball. Once they use their fireball, play a fireball bait card, like Three Musketeers. It's kind of like climate change. It's a hot topic, and it's sure to get some people fired up."
										color="lightBlueDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="common"
											titleBackground="commonTitle"
											cardTitle={ "fireball bait" }
											className="fireballBait"
											cardBackground="three-musketeers"
											archetypeName="fireballBait"/>

          {/*<div className="CardButtonPusher" />*/}
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building"
											text="Bridge Spam."
											color="redDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="rare"
											titleBackground="rareTitle"
											cardTitle={ "bridge spam" }
											className="bridgeSpam"
											cardBackground="battle-ram"
											archetypeName="bridgeSpam"/>


          <CardButton rarity="epic"
											titleBackground="epicTitle"
											cardTitle={ "dual lane" }
											className="dualLane"
											cardBackground="elite-barbarians"
											archetypeName="dualLane"/>
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building"
											text="It&#8217;s two brothers. In two lanes. And then a fireball hit. And then they ran as fast as they could. From giant dragon monsters. And then a giant tornado came. And that’s when things got knocked into 12th gear... Split up your troops and attack both towers at once, Morty. *burp*"
											color="purpleDescription"/>


					<CardButton rarity="common"
											titleBackground="commonTitle"
											cardTitle={ "spell cycle" }
											className="spellCycle"
											cardBackground="rocket"
											archetypeName="spellCycle"/>
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building"
											text="Where my witches at? Cast spells left and right, gaining value by hitting your opponent’s towers and troops at once."
											color="lightBlueDescription"/>


					<CardButtonDescription rarity="archetypeDescription"
										titleBackground="commonTitle"
										cardTitle={ "building" }
										className="building"
										cardBackground="inferno-tower"
										archetypeName="building"
										text="Annoying archetype for annoying people. Drop lots and lots of troop-spawning buildings and overwhelm your opponent with your ability to be annoying. Or don’t (please)."
										color="purpleDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="epic"
											titleBackground="epicTitle"
											cardTitle={ "hut spam" }
											className="hutSpam"
											cardBackground="goblin-hut"
											archetypeName="hutSpam"/>



        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/OffenseBox.js